import { useContext, useEffect, useState } from 'react'
import { TrashAlt } from '@styled-icons/boxicons-solid'
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'
import {
  HarnessListContext,
  SHOW_HIDE_HARNESS_SALES_CODE_POPUP,
} from '../context/context'
import {
  deleteRequest,
  getRequest,
  postRequest,
} from '../../../../services/base'
import Tooltip from '../../../common/tooltip'
import InputText from '../../../common/InputText'
import { NavContext } from '../../../../context/global_context'
import NoRecordsFound from '../../../common/NoRecordsFound'
import Button from '../../../common/Button'
import HarnessSalesCodeLevelsForm from './form'
import CheckBox from '../../../common/CheckBox'

const HarnessSalesCodeRelations = (props) => {
  const [navState, navDispatch] = useContext(NavContext)
  const [state, dispatch] = useContext(HarnessListContext)
  const [salesCodeData, setSalesCodeData] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [selectedRecords, setSelectedRecords] = useState([])

  useEffect(() => {
    getHarnessSalesCodeData(true)
  }, [])

  const getHarnessSalesCodeData = async (showLoader = true) => {
    if (showLoader) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Loading Harness Sales Code Data ...',
          showLoader: true,
        },
        notification: {},
      })
    }

    let res = await getRequest(
      `/api/harnesses/related_data/${state?.harnessSalesCodePopup?.id}/`
    )
    setSalesCodeData(res.data)
    searchSalesCodeOrPartNumber(res.data)
    navDispatch({
      type: 'loader',
      data: {
        caption: '',
        showLoader: false,
      },
      notification: {},
    })
  }

  const deleteHarnessSalesCodeLevels = async (id, index) => {
    if (
      window.confirm(
        `Are you sure want to delete, It will delete respective records.`
      )
    ) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Harness Sales Code levels Delete is in progress',
          showLoader: true,
        },
        notification: {},
      })
      let res = await deleteRequest(`/api/harnesses/related_data/delete/${id}/`)
      if (res?.status) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: res.msg,
          },
        })
        deleteSalesCodeData(id)
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res.msg,
          },
        })
      }
    }
  }

  const searchSalesCodeOrPartNumber = (data) => {
    let filteredSalesCodeData = []
    if (searchText) {
      filteredSalesCodeData = [...data].filter(
        (row) =>
          row['level'].name.toLowerCase().includes(searchText.toLowerCase()) ||
          row['option_code'].name
            .toLowerCase()
            .includes(searchText.toLowerCase())
      )
    } else {
      filteredSalesCodeData = [...data]
    }
    setFilteredData(filteredSalesCodeData)
  }

  const deleteSalesCodeData = (rowId) => {
    let tempSalesCodeData = [...salesCodeData]
    var ogIndex = salesCodeData.findIndex((obj) => obj.id === rowId)
    tempSalesCodeData.splice(ogIndex, 1)
    setSalesCodeData(tempSalesCodeData)

    let tempFilteredData = [...filteredData]
    var ogFilteredIndex = tempFilteredData.findIndex((obj) => obj.id === rowId)
    tempFilteredData.splice(ogFilteredIndex, 1)
    setFilteredData(tempFilteredData)
  }

  const selectRecords = (id) => {
    let tempRecords = [...selectedRecords]
    if (tempRecords.includes(id)) {
      let index = tempRecords.indexOf(id)
      tempRecords.splice(index, 1)
    } else {
      tempRecords.push(id)
    }
    setSelectedRecords(tempRecords)
  }

  const deleteSelectedHarnessRelations = async () => {
    if (
      window.confirm(
        `Are you sure want to delete, It will delete respective records.`
      )
    ) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Deleting Harness Sales Code Data ...',
          showLoader: true,
        },
        notification: {},
      })
      let formData = new FormData()
      selectedRecords.map((item, index) => {
        formData.append('id', item)
      })
      let res = await postRequest(
        `/api/harnesses/related_data/bulk/delete/`,
        formData
      )
      if (res?.status) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: res.msg,
          },
        })
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res.msg,
          },
        })
      }
      getHarnessSalesCodeData(false)
    }
  }

  return (
    <Modal
      onClose={() => {
        dispatch({
          type: SHOW_HIDE_HARNESS_SALES_CODE_POPUP,
          data: {},
        })
      }}
      show={true}
      size={`w-3/4`}
    >
      <ModalHeader className={'text-white'}>
        Sales Code & Part Number Mapping
      </ModalHeader>
      <ModalBody>
        <div className="font-light">
          <div className="flex flex-row w-full justify-end  text-white text-sm">
            <div className="w-1/2 flex items-center text-lg font-semibold">
              {state?.harnessSalesCodePopup?.harness_id}
            </div>
            <div className="flex w-1/2 items-center">
              <div className="flex items-center w-full pr-2">
                <InputText
                  name="search_value"
                  placeholder={`Enter to Search Sales Code Or Part Number`}
                  className={`w-100`}
                  value={searchText}
                  isFullSize={true}
                  type="search"
                  onChange={(value) => {
                    setSearchText(value)
                  }}
                  isRequired={false}
                  wrapperClass={`pl-0`}
                />
                <Button
                  className={`cursor-pointer btn`}
                  text={`Search `}
                  onClick={() => {
                    searchSalesCodeOrPartNumber(salesCodeData)
                  }}
                />
              </div>
              <div className="pr-2">
                <Button
                  className={`cursor-pointer btn`}
                  text="Delete Selected"
                  onClick={() => {
                    deleteSelectedHarnessRelations()
                  }}
                />
              </div>

              <HarnessSalesCodeLevelsForm
                getHarnessSalesCodeData={() => getHarnessSalesCodeData(false)}
              />
            </div>
          </div>
        </div>
        <div className="font-light">
          <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3">
            <div className="flex w-1/12 items-center justify-center"></div>
            <div className="flex w-5/12 items-center">Sales Code</div>
            <div className="flex w-5/12 pl-6 items-center">Part Number</div>
            <div className="flex w-1/12 items-center justify-center"></div>
          </div>
        </div>

        <div
          style={{
            height: '50vh',
            overflowY: 'scroll',
            position: 'relative',
          }}
        >
          {filteredData?.map((sales_code_detail, index) => {
            return (
              <div
                key={`sales-code-details-${index}`}
                className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black"
              >
                <div className="flex w-1/12 items-center justify-center">
                  <CheckBox
                    name={`harness_sales_code_level_[${sales_code_detail.id}]`}
                    value={sales_code_detail.id}
                    checked={selectedRecords.includes(sales_code_detail.id)}
                    onChange={() => {
                      selectRecords(sales_code_detail.id)
                    }}
                  />
                </div>
                <div className="flex w-5/12 items-center table_text">
                  <Tooltip message={sales_code_detail.option_code?.name}>
                    <div>{sales_code_detail.option_code?.name}</div>
                  </Tooltip>
                </div>
                <div className="flex w-5/12 pl-6 items-center table_text">
                  <Tooltip message={sales_code_detail.level?.name}>
                    <div>{sales_code_detail.level?.name}</div>
                  </Tooltip>
                </div>
                <div className="flex w-1/12 pl-6 items-center table_text">
                  <span
                    className="cursor-pointer"
                    onClick={() => {
                      deleteHarnessSalesCodeLevels(sales_code_detail.id)
                    }}
                  >
                    <TrashAlt size="2rem" color="#0189E9" />
                  </span>
                </div>
              </div>
            )
          })}
          {filteredData?.length < 1 && (
            <NoRecordsFound caption="No Record Found!" />
          )}
        </div>
      </ModalBody>
    </Modal>
  )
}

export default HarnessSalesCodeRelations
